<template>
  <div class="fill-height text-center d-flex flex-column justify-space-around px-6 all-container">
    <div class="success--text text--darken-2">
      <h1>{{ $t('GAME.CARDS.OVER') }}</h1>
      <ScoreDrawer v-if="isClassMode" :score="score" class="big" />
      <div v-else>
        <h2>+{{ $store.getters['cards/score'] }} {{ $t('GAME.POINTS')}}</h2>
      </div>
    </div>

    <div class="d-flex justify-center">
    </div>

    <div>
      <BaseButton
        class="my-5"
        @click="$router.back()"
      >
        {{ $t('BACK') }}
      </BaseButton>
    </div>
  </div>
</template>

<style scoped>
.all-container {
  margin: auto;
  max-width: 500px;
  width: 100%;
}

.big {
  font-size: 32px;
  font-weight: bold;
}
</style>

<script>
import ScoreDrawer from '@/components/navigation/ScoreDrawer.vue';

export default {
  name: 'CardsGameOver',
  components: {
    ScoreDrawer,
  },
  computed: {
    score() {
      if (this.isClassMode) {
        return this.$store.getters['classMode/score']('cards');
      }

      return this.$store.getters['cards/score'];
    },
  },
};
</script>
